import { urlSchema } from '../../../schemas/common/url.js';
import { z } from 'zod';
import { addressSchema } from '../../Address.js';
import { creditsSchema } from '../../Credits.js';
import { overflowFeesSchema } from '../../OverflowFees.js';
import { payableDataSchema } from '../../Payable.js';
import { inventoryServiceConfigSchema } from '../configurations/InventoryServiceConfig.js';
import { servicesProviderGenericDataSchema, planDetailsSchema } from '../ServicesProviderData.js';
import { Services } from './Services.js';

const servicesProviderInventoryDataSchema = servicesProviderGenericDataSchema
    .merge(payableDataSchema)
    .extend({
    config: z.object({
        [Services.INVENTORY]: inventoryServiceConfigSchema,
    }),
    analyticsBoardUrl: urlSchema,
    planDetails: planDetailsSchema,
    credits: creditsSchema,
    overflow: z.object({
        overflowFeesArray: z.array(overflowFeesSchema),
    }),
    physicalAddress: addressSchema,
});

export { servicesProviderInventoryDataSchema };
//# sourceMappingURL=ServicesProviderInventoryData.js.map
